import React from 'react';
import { Global, css } from '@emotion/react';
import Head from 'next/head';

/**
 * Why crossOrigin="anonymous" on the link preloads?
 * See https://github.com/w3c/preload/issues/32 & https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types/preload#cors-enabled_fetches
 * In short: for fonts it's a micro perf gain to set the default crossOrigin val
 */

/**
 * Load ZooplaDisplay with @font-face via @emotion/global and preload link via
 * next/head
 */
const ZooplaDisplayFontFamilyGlobals: React.FC = () => (
    <>
        <Global
            styles={css`
                @font-face {
                    font-family: 'ZooplaDisplay';
                    font-style: normal;
                    font-weight: bold;
                    font-display: swap;
                    src: local('ZooplaDisplay-Bold'),
                        url('/fonts/ZooplaDisplay-Bold.woff2') format('woff2'),
                        url('/fonts/ZooplaDisplay-Bold.woff') format('woff');
                }
            `}
        />
        <Head>
            <link
                rel="preload"
                as="font"
                href="/fonts/ZooplaDisplay-Bold.woff2"
                type="font/woff2"
                crossOrigin="anonymous"
            />
        </Head>
    </>
);

/**
 * Load Lato with @font-face via @emotion/global and preload link via next/head
 */
const LatoFontFamilyGlobals: React.FC = () => (
    <>
        <Global
            styles={css`
                @font-face {
                    font-family: Lato;
                    font-style: normal;
                    font-weight: normal;
                    font-display: swap;
                    src: local('Lato'),
                        url('/fonts/LatoLatin-Regular.woff2') format('woff2'),
                        url('/fonts/LatoLatin-Regular.woff') format('woff');
                }
                @font-face {
                    font-family: Lato;
                    font-style: normal;
                    font-weight: bold;
                    font-display: swap;
                    src: local('Lato'), local('Lato'),
                        url('/fonts/LatoLatin-Bold.woff2') format('woff2'),
                        url('/fonts/LatoLatin-Bold.woff') format('woff');
                }
            `}
        />
        <Head>
            <link
                rel="preload"
                as="font"
                href="/fonts/LatoLatin-Regular.woff2"
                type="font/woff2"
                crossOrigin="anonymous"
            />
            <link
                rel="preload"
                as="font"
                href="/fonts/LatoLatin-Bold.woff2"
                type="font/woff2"
                crossOrigin="anonymous"
            />
        </Head>
    </>
);

/**
 * Apply Lato font family to body via @emotion/react Global
 */
const LatoFontBodyGlobals: React.FC = () => (
    <>
        {/* Override inlined header & footer "global" style class to inherit */}
        <Global
            styles={css`
                body
                    .z-bui-component.z-bui-component
                    .css-4oozw0-GlobalProvider {
                    font-family: inherit;
                }
            `}
        />
        <Global
            styles={css`
                body {
                    font-family: Lato, Helvetica, Arial, sans-serif;
                }
            `}
        />
    </>
);

export {
    LatoFontFamilyGlobals,
    LatoFontBodyGlobals,
    ZooplaDisplayFontFamilyGlobals
};
